var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Input, Spin } from 'antd';
import CustomButton from '../../Shared/CustomButton/CustomButton';
import { useEffect, useRef, useState, } from 'react';
import './CaenActivitySection.scss';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import analytics from '../../../utils/Services/analytics';
import { useDebounce } from 'use-debounce';
var CaenActivitySection = function (props) {
    var activities = props.activities, inputRef = props.inputRef, onActivitySelect = props.onActivitySelect, handleInputBlur = props.handleInputBlur;
    var _a = useState(''), searchCriteria = _a[0], setSearchCriteria = _a[1];
    var _b = useState(undefined), searchResults = _b[0], setSearchResults = _b[1];
    var _c = useState(undefined), selectedActivity = _c[0], setSelectedActivity = _c[1];
    var debouncedInputValue = useDebounce(searchCriteria, 450)[0];
    var _d = useState(''), latestGUID = _d[0], setLatestGUID = _d[1];
    var _e = useState(false), isSearchLoading = _e[0], setIsSearchLoading = _e[1];
    var _f = useState(true), showSearchWindow = _f[0], setShowSearchWindow = _f[1];
    var _g = useState(false), forceRerender = _g[0], setForceRerender = _g[1];
    var widgetRef = useRef(null);
    useEffect(function () {
        setSearchCriteria('');
        var handleClickOutside = function (event) {
            // Check if the clicked element is inside the widget
            if (widgetRef.current &&
                !widgetRef.current.contains(event.target)) {
                // Clicked outside the widget, hide it
                setShowSearchWindow(false);
            }
        };
        // Attach the event listener to the document
        document.addEventListener('click', handleClickOutside);
        // Cleanup the event listener on component unmount
        return function () {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    useEffect(function () {
        var guid = uuidv4();
        setLatestGUID(guid);
    }, [debouncedInputValue, forceRerender]);
    useEffect(function () {
        if (debouncedInputValue.length >= 1 && latestGUID !== '')
            axios
                .post('/api/caen/search', {
                Guid: latestGUID,
                Input: debouncedInputValue,
            })
                .then(function (response) {
                setIsSearchLoading(false);
                if (response.data.Guid === latestGUID) {
                    setSearchResults(response.data.Results);
                }
            })
                .catch(function (err) {
                console.log(err);
                setIsSearchLoading(false);
            });
    }, [latestGUID]);
    var handleInputChange = function (e) {
        var newValue = e.target.value;
        setSearchCriteria(newValue);
        //If we type fast, but the end result is equal to the initial sequence that was before
        // Example: me => m => me again, we need to trigger a forced rerender
        if (newValue === debouncedInputValue && newValue.length >= 1) {
            setForceRerender(!forceRerender);
        }
        setIsSearchLoading(true);
        setSearchResults([]);
        setLatestGUID('');
        if (newValue.length < 1) {
            setShowSearchWindow(false);
            return;
        }
        setShowSearchWindow(true);
    };
    var handleButtonClick = function (activity) {
        setSearchCriteria('');
        setSearchResults([]);
        setSelectedActivity(activity);
        onActivitySelect(activity);
        if (activity) {
            analytics.Log('tool_caen_click_activitate', {
                tip_activitate: activity.Code,
            });
        }
    };
    var handleInputClick = function () {
        analytics.Log('tool_caen_click_search', {});
    };
    return (_jsxs("div", __assign({ className: "caen-activity" }, { children: [_jsx("h2", __assign({ className: "caen-activity__title" }, { children: "Selecteaz\u0103 activitatea" })), selectedActivity !== undefined ? (_jsxs("div", __assign({ className: "caen-activity__container-selected" }, { children: [_jsx(CustomButton, __assign({ selected: true }, { children: selectedActivity.Name })), _jsxs(Button, __assign({ className: "caen-activity__back-button", type: "link", onClick: function () { return handleButtonClick(undefined); } }, { children: [_jsx("img", { className: "caen-activity__back-button--icon", src: "/icons/DeductibleExpenses/left-arrow.svg", alt: "left-arrow" }), "Alege alt\u0103 activitate"] }))] }))) : (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "caen-activity__buttons" }, { children: activities === undefined || activities.length === 0 ? (_jsx("div", __assign({ className: "caen-activity__spin-center" }, { children: _jsx(Spin, {}) }))) : (activities
                            .map(function (activity, index) { return (_jsx(CustomButton, __assign({ onClick: function () {
                                handleButtonClick(activity);
                            } }, { children: activity.Name }), index)); })) })), _jsxs("div", __assign({ className: "caen-activity__separator" }, { children: [_jsx("span", {}), _jsx("p", __assign({ className: "caen-activity__separator-word" }, { children: "Sau" })), _jsx("span", {})] })), _jsxs("div", __assign({ className: "caen-activity__input-container" }, { children: [_jsx(Input, { className: "caen-activity__input", prefix: _jsx("img", { src: "/icons/Caen/search.svg" }), value: searchCriteria, onChange: handleInputChange, onClick: handleInputClick, placeholder: "Caut\u0103 activitate", ref: inputRef, onBlur: handleInputBlur }), searchCriteria.length >= 1 && showSearchWindow && (_jsx("div", __assign({ className: "caen-activity__search-results", ref: widgetRef }, { children: isSearchLoading ? (_jsx("div", __assign({ className: "caen-activity__spin-center" }, { children: _jsx(Spin, {}) }))) : (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) === 0 ? ('Nu au fost găsite rezultate.') : (searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(function (caenAactivity, index) { return (_jsxs("div", __assign({ className: "caen-activity__search-item", onClick: function () {
                                        handleButtonClick(caenAactivity);
                                        analytics.Log('tool_caen_search_click_activitate', {
                                            tip_activitate: caenAactivity.Code,
                                        });
                                    } }, { children: [caenAactivity.Name, _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, { children: _jsx("path", { d: "M10.8055 12.4715C10.5451 12.7318 10.123 12.7318 9.86265 12.4715C9.6023 12.2111 9.6023 11.789 9.86265 11.5287L12.0579 9.33341H3.33333C2.59695 9.33341 2 8.73646 2 8.00008V4.00008C2 3.63189 2.29848 3.33341 2.66667 3.33341C3.03486 3.33341 3.33333 3.63189 3.33333 4.00008V7.33341C3.33333 7.7016 3.63181 8.00008 4 8.00008L11.9909 8.00008L9.86267 5.87181C9.60231 5.61146 9.60231 5.18935 9.86267 4.929C10.123 4.66866 10.5451 4.66865 10.8055 4.929L13.6339 7.75743C13.8292 7.9527 13.9512 8.19346 14 8.44559C14.0814 8.86581 13.9593 9.31762 13.6339 9.64306L10.8055 12.4715Z", fill: "#939393" }) }))] }), index)); })) })))] }))] }))] })));
};
export default CaenActivitySection;
